<template>
  <div class="results">
    <Background :pump="null" :time="'day'"></Background>
    <Endchallenge :allresults="true" @restart="nextChallenge($event)" @next="nextChallenge($event)" @exit="$router.push('/')" ></Endchallenge>
  </div>
</template>

<script>

import Background from '@/components/Background.vue'
import Endchallenge from '@/views/Endchallenge.vue'

export default {
  name: 'results',
  data: function () {
    return {
    }
  },
  components: {
    Endchallenge,
    Background
  },
  mounted: function () {
  },
  methods: {
    nextChallenge: function (ev) {
      this.$router.push('/challenge/' + ev)
    }
  },
  computed: {
  }
}
</script>

<style scoped lang="scss" >
.results{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
